import '@tylertech/forge/badge';

export interface ExtensionDataBadgeProps {
  extensionData?: Record<string, unknown> | null;
}

export function ExtensionDataBadge({ extensionData }: ExtensionDataBadgeProps): JSX.Element | null {
  if (!extensionData || Object.keys(extensionData).length === 0) {
    return null;
  }

  const BadgeElement = 'forge-badge' as React.ElementType;

  return (
    <BadgeElement theme="info-secondary" className="extension-data-badge">
      Custom data preserved
    </BadgeElement>
  );
}
